/**
 * Configurazione di Debug
 * Vengonod definite tutte le variabili utilizzate per getire il debug dell'applicazione
 */

const D = [
    {
        name: "IS_DEVELOPMENT",
        development: true,
        release: false,
    },
    {
        // stampo nella descrizione di ogni card di ogni widget informazioni aggiuntive sulla configurazione
        name: "PRINT_WIDGET_INFO",
        development: false,
        release: false,
    },
    {
        // stampo il console.time per ogni fetch dei dati del widget
        name: "PRINT_WIDGET_FETCH_TIME",
        development: false,
        release: false,
    },
    {
        // mostro il sidebar link per la pagina di debug
        name: "SHOW_DEBUG_PAGE",
        development: true,
        release: false,
    },
];

const exp = Object.assign(
    {},
    ...D.map((d) => ({
        [d.name]: process.env.NODE_ENV == "development" ? d.development : d.release,
    }))
);

// console.log("DebugConfig", exp);

export default exp;
